import React from 'react';
import L from 'leaflet';
import ReactDOMServer from 'react-dom/server';
import Icon3 from '../ReactIcons/icon3';
import { ICON_ANCHOR, ICON_SIZE } from '.';

const mapIcon3 = L.divIcon({
    html: ReactDOMServer.renderToString(<Icon3 />),
    iconSize: ICON_SIZE,
    iconAnchor: ICON_ANCHOR
});

export default mapIcon3;